
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.25 23.25a2.407 2.407 0 01-1.766-.734A2.407 2.407 0 01.75 20.75V3.25c0-.688.245-1.276.734-1.766A2.407 2.407 0 013.25.75h17.5c.688 0 1.276.245 1.766.734.49.49.734 1.079.734 1.766v17.5c0 .688-.245 1.276-.734 1.766-.49.49-1.078.734-1.766.734H3.25zm0-2.5h7.5V3.25h-7.5v17.5zm10 0h7.5V12h-7.5v8.75zm0-11.25h7.5V3.25h-7.5V9.5z","fill":"#fff"}})])
          )
        }
      }
    